import * as React from "react";
import { Button } from "../Button/Button";
import { cn } from "../../../helpers";
import ChevronDownIcon from "../../icons/ChevronDown";
import styles from "./FilterButton.module.scss";

interface FilterButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    // Button text
    text: React.ReactNode;
    // Extra classnames for styling
    classNames?: string;
    // Icon stroke color
    stroke?: string;
}

const FilterButton = React.forwardRef<HTMLButtonElement, FilterButtonProps>(
    ({ text, classNames, stroke, ...props }, ref) => {
        return (
            <Button
                size="auto"
                variant="normal"
                className={cn(styles.filterButton, classNames)}
                ref={ref}
                {...props}
            >
                {text}
                <ChevronDownIcon stroke={stroke || "#0b132b"} />
            </Button>
        );
    }
);

FilterButton.displayName = "FilterButton";
export default FilterButton;
